/*
 * Plays muted looping background/reel videos only while they are on screen.
 * Videos opt in with the class "js-autoplay-visible" (rendered without the
 * autoplay attribute and with preload="none", so off-screen and hidden
 * mobile/desktop copies don't download until needed).
 */
(function () {
  if (window.__autoplayVisibleInit) return;
  window.__autoplayVisibleInit = true;

  function isRendered(video) {
    return video.getClientRects().length > 0;
  }

  // Respect the Shoppable Reels "pause inactive videos" setting on mobile slides.
  function blockedByCarousel(video) {
    var slide = video.closest('[data-svr-slide]');
    if (!slide) return false;
    var root = slide.closest('[data-pause-inactive]');
    return !!(root && root.dataset.pauseInactive === 'true' && !slide.classList.contains('is-active'));
  }

  function play(video) {
    if (!isRendered(video) || blockedByCarousel(video)) return;
    video.muted = true;
    video.playsInline = true;
    if (video.preload === 'none') video.preload = 'auto';
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function playAll(videos) {
    videos.forEach(function (v) {
      if (v.__inView) play(v);
    });
  }

  function init() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('video.js-autoplay-visible'));
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) {
        v.__inView = true;
        play(v);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          v.__inView = entry.isIntersecting;
          if (entry.isIntersecting) {
            play(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    videos.forEach(function (v) {
      observer.observe(v);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        videos.forEach(function (v) {
          if (!v.paused) v.pause();
        });
      } else {
        playAll(videos);
      }
    });

    // Re-check when crossing the mobile/desktop breakpoint (different copies become visible).
    var resizeTimer;
    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          playAll(videos);
        }, 200);
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
